import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useApplication } from '@/context/application.provider';

interface ProtectedRouteProps {
  children: ReactNode;
  requireAuth?: boolean;
}

const ProtectedRoute = ({ children, requireAuth = true }: ProtectedRouteProps) => {
  const { auth } = useApplication();
  const { isLogged, token } = auth;
  const location = useLocation();

  if (requireAuth) {
    if (!isLogged) {
      return <Navigate replace state={{ from: location }} to="/login" />;
    }

    return children;
  }

  if (isLogged && token) {
    return <Navigate replace to="/home" />;
  }

  return children;
};

export default ProtectedRoute;
